import historyManager from './history-manager';

export default {
  historyManager,
};
